import React from 'react';
import LFCChartsParetoYMD from './LFCChartsParetoYMD';
import LFCChartsBarYMD2 from './LFCChartsBarYMD2';

export interface TogglableFailureChartProps {
  mode: 'bar' | 'pareto';
  chartType: 'model' | 'method' | 'location';
  title: string;
  source: any;
  xList: any;
  y: {
    type: 'time' | 'value' | 'category';
    dsColumn: string;
  };
  series: string;
  exportData: any;
  exportFields: Record<string, string>;
  exportFilename: string;
  chartToggleStatus?: boolean;
  onChartToggle?: () => void;
  timeUnit?: number;
  zoomChartId: string;
  zoomedChartId?: string;
  zoomCharts?: (zoomChartId?: string) => void;
  zoomChartsClose?: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
}

const TogglableFailureChart: React.FC<TogglableFailureChartProps> = ({
  mode,
  chartType,
  title,
  source,
  xList,
  y,
  series,
  exportData,
  exportFields,
  exportFilename,
  chartToggleStatus = true,
  onChartToggle,
  timeUnit,
  zoomChartId,
  zoomedChartId,
  zoomCharts,
  zoomChartsClose
}) => {
  const commonProps = {
    source,
    xList,
    y,
    series,
    grid: {
      top: '40',
      left: '60',
      right: '63',
      bottom: '93'
    },
    height: '40vh',
    exportData,
    exportFields,
    chartToggleStatus,
    onChartToggle,
    zoomChartId,
    zoomedChartId,
    zoomCharts,
    zoomChartsClose
  };

  if (mode === 'pareto') {
    return (
      <LFCChartsParetoYMD
        {...commonProps}
        title={`${title} - パレート図`}
        exportFilename={`${exportFilename} - パレート図`}
        isParetoMode={true}
        timeUnit={timeUnit}
      />
    );
  } else {
    return (
      <LFCChartsBarYMD2
        {...commonProps}
        title={title}
        exportFilename={exportFilename}
        isParetoMode={false}
        stacked
      />
    );
  }
};

export default TogglableFailureChart;
